/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-debugger */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/control-has-associated-label */

import { motion } from 'framer-motion';
import React, {
    useState, useRef, useCallback, useEffect,
} from 'react';
import { distributorService } from '../../service/distributor.service';
import Pagination from '../../Components/Pagination';
import ItemSkeleton from '../../Components/Skeletons/itemSkeleton';
import ExportModal from './ExportModal';

export default function ListingTable(props) {
    const {
        currentPage,
        totalPage,
        list,
        item,
        handlePageClick,
        productLoading,
        subMenuAnimate,
        setspinner,
        setshowPopup,
        title,
        settitle,
    } = props;
    const [width, setwidth] = useState(30);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [color, setcolor] = useState(false);
    const [search, setsearch] = useState('');
    const myRef = useRef();
    const onScroll = () => {
        const { scrollX } = window;
        const { scrollRight } = myRef.current;
        setwidth(scrollRight);
    };
    const handleNulldata = (data) => (data === null ? '-' : data);
    const handleSkuExport = useCallback((() => {
        if (exportClick) {
            setspinner(true);
        }
        const payload = {
            concat_segments: item.concat_segments,
            page: item.current_page,
            limit: 10,
        };
        distributorService.handleProductsExport(exportSelected, payload).then((value) => {
            if (value.data.success_status) {
                setspinner(false);
                setshowPopup(true);
                settitle(value.data.message);
                window.open(value.data.url, '_blank');
                setexportClick(false);
                setexportSelected('');

                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 3000);
            }
        });
    }), [exportSelected]);
    useEffect(() => {
        handleSkuExport();
    }, [handleSkuExport]);

    return (
        <motion.div
            animate="enter"
            variants={subMenuAnimate}
            className="mt-4 bg-[#E8E8F3] p-3 rounded-lg"
        >
            {/* <div className="w-full h-2 bg-[#FFFFFF] rounded-lg mt-5">
                <div className="bg-[#090406] h-2 rounded-lg" style={{ width: `${width}%` }} />
            </div> */}
            <div className="mt-[22px]">

                <div className="flex">
                    <div className="relative">
                        <label htmlFor="search" />
                        <input
                            value={search}
                            type="text"
                            onChange={(e) => {
                                setsearch(e.target.value.trim());
                                handlePageClick(item.current_page, list, item, e.target.value.trim());
                            }}
                            name="search"
                            id="search"
                            className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                    </div>
                    {list?.length > 0 && (
                        <ExportModal
                            exportClick={exportClick}
                            setexportClick={setexportClick}
                            subMenuAnimate={subMenuAnimate}
                            setexportSelected={setexportSelected}
                            csv="export-sku-csv"
                            pdf="html-to-pdf"
                            excel="export-sku-excel"

                        />
                    )}
                </div>
            </div>
            <div className="overflow-auto pt-[18px] pb-7 relative z-0 list ">
                {!productLoading ? (
                    <>
                        {list?.length > 0
                            ? (
                                <motion.table
                                    animate={{ opacity: 1, x: 0 }}
                                    initial={{ opacity: 0, x: -10 }}
                                    exit={{ opacity: 0, x: -10 }}
                                    transition={{ duration: 0.15 }}
                                    className="w-full table-auto relative"
                                    ref={myRef}
                                    onScroll={() => onScroll()}
                                    style={{ overflow: 'scroll' }}
                                >
                                    <div className="">
                                        <thead>
                                            <tr className="bg-[#555259] h-10">
                                                <th scope="col" className="py-3 px-4  min-w-[160px] rounded-bl-lg rounded-tl-lg ">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Product Image
                                                    </span>
                                                </th>
                                                <th className="py-3 px-4 min-w-[100px] bg-[#555259]" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        ITEM CODE
                                                    </span>
                                                </th>
                                                <th className="py-3 px-4 min-w-[160px] bg-[#555259] text-left" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Product Name
                                                        <a href="#" className="pl-[5px]">
                                                            <img src="/images/sort.svg" alt="icon" />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th className="py-3 px-4 min-w-[650px] bg-[#555259] text-left" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Product Description
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-3 px-4 min-w-[100px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        UoM
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-3 px-4 min-w-[100px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        MOQ
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-3 px-4 min-w-[200px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Standard Pack Size
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-3 px-4 min-w-[120px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Size
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-3 px-4 min-w-[200px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Delivery Lead Time
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-3 px-4 min-w-[200px] rounded-tr-lg rounded-br-lg">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        AWS Classification
                                                    </span>
                                                </th>
                                            </tr>
                                            <tr aria-colspan="8" className="h-4">
                                                <td />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list?.length > 0 && list.map((product, i) => (
                                                <>
                                                    {' '}
                                                    <motion.tr
                                                        animate={{ opacity: 1, x: 0 }}
                                                        initial={{ opacity: 0, x: -10 }}
                                                        exit={{ opacity: 0, x: -10 }}
                                                        transition={{ duration: 0.15 }}
                                                        className="bg-[#FDFDFE] border-b border-[#DFEAF7]"
                                                        key={`product-${i}`}
                                                    >
                                                        <td className="py-2.5 px-4">
                                                            <img src="/images/Image 21.png" alt="" />
                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product.CONCATENATED_SEGMENTS)}
                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product?.DESCRIPTION.split(' ')[0])}
                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product.DESCRIPTION)}
                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product.PRIMARY_UOM_CODE)}
                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {' '}
                                                            {handleNulldata(product.MINIMUM_ORDER_QUANTITY)}
                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product.PACKING_SIZE)}
                                                            {' '}

                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product.LENGTH) * handleNulldata(product.DIAMETER)}

                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product.DELIVERY_LEAD_TIME)}
                                                        </td>
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-4">
                                                            {handleNulldata(product.AWS_CLASSIFICATION)}
                                                        </td>
                                                    </motion.tr>
                                                    <tr aria-colspan="8" className="h-2">
                                                        <td />
                                                    </tr>
                                                </>
                                            ))}
                                        </tbody>
                                    </div>
                                </motion.table>
                            )
                            : <div className="flex justify-center items-center"><p>Ooops!! No products found</p></div>}

                    </>

                ) : <ItemSkeleton isProductListing />}

            </div>
            {totalPage > 1 && list?.length > 0 && (
                <Pagination isSkeleton handlePageClick={handlePageClick} List={list} search={search} currentPage={currentPage} totalPage={totalPage} item={item} />
            )}
        </motion.div>

    );
}
